module.exports = __webpack_public_path__ + "img/pop.44c580df.jpg";